import { Routes } from '@angular/router';
import { PermissionGuard } from '../guards/permission.guard';
import { UserRole } from '../models/enums/UserRole';
import { PartnerPortalLayoutComponent } from '../partner-portal/partner-portal-layout/partner-portal-layout.component';
import { OperationsDashboardComponent } from '../operations-portal/dashboard/operations-dashboard.component';
import { OperationsRequestsComponent } from '../operations-portal/requests/operations-requests.component';
import { ViewProfileComponent } from '../student-portal/view-profile/view-profile.component';
import { OperationsStudentsComponent } from '../operations-portal/students/operations-students.component';
import { MentorsListComponent } from '../super-admin/mentors-list/mentors-list.component';
import { InstituteSearchComponent } from '../student-portal/institute-search/institute-search.component';

export const operationsRoutes: Routes = [
  {
    path: 'operations-portal',
    component: PartnerPortalLayoutComponent,
    data: { portal: 'partner' },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'mentors',
        component: MentorsListComponent,
        data: { expectedRoles: [UserRole.Operations] },
        canActivate: [PermissionGuard]
      },
      {
        path: 'dashboard',
        component: OperationsDashboardComponent,
        data: { expectedRoles: [UserRole.Operations] },
        canActivate: [PermissionGuard]
      },
      {
        path: 'requests',
        component: OperationsRequestsComponent,
        data: { expectedRoles: [UserRole.Operations] },
        canActivate: [PermissionGuard]
      },
      {
        path: 'essay-pilot',
        loadComponent: () => import('../operations-portal/essay-pilot/essay-pilot.component').then(m => m.EssayPilotComponent),
        data: { expectedRoles: [UserRole.Operations] },
        canActivate: [PermissionGuard]
      },
      {
        path: 'students',
        component: OperationsStudentsComponent,
        data: { expectedRoles: [UserRole.Operations] },
        canActivate: [PermissionGuard]
      },
      {
        path: 'view-profile/:id',
        component: ViewProfileComponent,
        data: { expectedRoles: [UserRole.Operations] },
        canActivate: [PermissionGuard]
      },
      {
        path: 'student/:id/details',
        loadComponent: () => import('../operations-portal/student/student-details/student-details.component').then(m => m.StudentDetailsComponent),
        data: { expectedRoles: [UserRole.Operations] },
        canActivate: [PermissionGuard]
      },
      {
        path: 'institute-search/:id',
        component: InstituteSearchComponent,
        data: {
          expectedRoles: [UserRole.Operations],
        },
        canActivate: [PermissionGuard]
      }
    ]
  }
];
